import React from "react";

function HomeHeaderActive() {
  return (
    <svg fill="#1b74e4" width="28" height="28"   viewBox="0 0 28 28">
      <path d="M 9.464 1.286 C 10.294 0.803 11.092 0.5 12 0.5 c 0.908 0 1.707 0.303 2.537 0.786 c 0.795 0.462 1.7 1.142 2.815 1.977 l 2.232 1.675 c 1.391 1.042 2.359 1.766 2.888 2.826 c 0.53 1.059 0.53 2.268 0.528 4.006 v 4.3 c 0 1.355 0 2.471 -0.119 3.355 c -0.124 0.928 -0.396 1.747 -1.052 2.403 c -0.657 0.657 -1.476 0.928 -2.404 1.053 c -0.884 0.119 -2 0.119 -3.354 0.119 H 7.93 c -1.354 0 -2.471 0 -3.355 -0.119 c -0.928 -0.125 -1.747 -0.396 -2.403 -1.053 c -0.656 -0.656 -0.928 -1.475 -1.053 -2.403 C 1 18.541 1 17.425 1 16.07 v -4.3 c 0 -1.738 -0.002 -2.947 0.528 -4.006 c 0.53 -1.06 1.497 -1.784 2.888 -2.826 L 6.65 3.263 c 1.114 -0.835 2.02 -1.515 2.815 -1.977 Z M 10.5 13 A 1.5 1.5 0 0 0 9 14.5 V 21 h 6 v -6.5 a 1.5 1.5 0 0 0 -1.5 -1.5 h -3 Z"></path>
    </svg>
  );
}

export default HomeHeaderActive;
